import useRouter from "@stadium/hooks/lib/use-custom-route";

import useTemplateInfoModal from "@hooks/use-template-info-modal";
import { usePageNameContext } from "@stadium/shared/page-name-provider";

import UseTemplateCTA from "@sharedComponents/content-links/use-template-cta";
import SelectItemsCta from "@sharedComponents/content-links/select-items";
import Multimedia from "@sharedComponents/multimedia";

import { camelizeKeys } from "@stadium/helpers/formatter";
import { getShopSendItemsRoute } from "@helpers/routes";
import { getCreateNewShopRoute } from "@stadium/helpers/app-routes";

import { MOMENTS } from "@constants/routes";

import { useWorkspaceContext } from "@stadium/hooks/lib/workspace";

import styles from "./main.module.scss";

const emptyObj = {};

const SearchTemplateHit = ({ hit, onTemplateSelect, forBanners }) => {
  const { push } = useRouter();
  const formattedHit = camelizeKeys(hit);
  const {
    topBannerImage = "",
    storeName = "",
    storeNumber = "",
    storeCode,
    feUrl,
  } = formattedHit || emptyObj;
  const { workspaceSlug } = useWorkspaceContext();
  const useTemplateUrl = getCreateNewShopRoute({
    shopNumber: storeNumber,
    shopCode: storeCode,
    workspaceSlug,
  });
  const pageName = usePageNameContext();
  const isMomentPage = pageName === MOMENTS;

  const [openTemplateInfoModal, renderTemplateInfoModal] = useTemplateInfoModal(
    {
      ...formattedHit,
      onTemplateSelect,
    },
    styles.searchResultsModal,
  );

  const handleTileClick = () => {
    if (isMomentPage) return push(getShopSendItemsRoute(feUrl));
    return openTemplateInfoModal();
  };

  const handleUseTemplateClick = () => {
    onTemplateSelect(useTemplateUrl);
  };

  const renderSearchedTile = () => (
    <>
      <div className={styles.imgContainer}>
        <Multimedia
          type="image"
          src={topBannerImage}
          className={styles.imgContainer}
          alt={storeName}
          width={300}
          height={100}
        />
      </div>
      <div className={styles.searchResultsTitleHolder}>
        <div className={styles.titleContainer}>
          <span>{storeName}</span>
        </div>
        <div className={styles.searchResultsContentLinkHolder}>
          {isMomentPage ? (
            <SelectItemsCta
              className={styles.searchResultsContentLink}
              pageName={pageName}
              feUrl={feUrl}
              storeName={storeName}
              storeNumber={storeNumber}
            />
          ) : (
            <UseTemplateCTA
              className={styles.searchResultsContentLink}
              pageName={pageName}
              storeName={storeName}
              storeNumber={storeNumber}
              onTemplateSelect={handleUseTemplateClick}
            />
          )}
        </div>
      </div>
    </>
  );

  if (forBanners) return null;

  return (
    <>
      <div className={styles.searchResultsContentRow} onClick={handleTileClick}>
        {renderSearchedTile()}
      </div>
      {renderTemplateInfoModal}
    </>
  );
};

export default SearchTemplateHit;
